// La cadena de la venta que originó el crédito del cliente: el negocio con el que se piden sus
// verificaciones y su tienda de alta.
import type { CustomerCreditDetail } from '@/domains/sales/portal/customers/api/useCustomerCredit';

/**
 * El `retailerId` del crédito vigente; si no lo trae, el del crédito más reciente que lo traiga.
 * `null` si el crédito no está leído o ninguno trae la cadena.
 */
export function saleRetailerOf(credit: CustomerCreditDetail): string | null {
    if (credit.state !== 'ready') return null;
    const { credits, activeCredit } = credit.data;

    const active = credits.find((item) => item.creditId === activeCredit?.creditId);
    const activeRetailer = active?.saleContext?.retailerId;
    if (activeRetailer) return activeRetailer;

    return credits.find((item) => item.saleContext?.retailerId)?.saleContext?.retailerId ?? null;
}
